<template>
  <v-card
    elevation="2"
    outlined
  >
    <v-toolbar
      class="primaryLight white--text"
      dense
    >
      <div>INFORMACIÓN NECESARIA PARA LA ACTUACIÓN</div>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          class="pb-0"
        >
          <div
            class="subtitle-2 font-weight-bold"
          >
            Director de Extinción y Comunicaciones
          </div>
        </v-col>
        <v-col
          cols="3"
        >
          <v-text-field
            v-model="datos.dirExtincion"
            label="Director extinción*"
            :rules="reglas.requerido"
            hide-details
          />
        </v-col>
        <v-col
          cols="3"
        >
          <v-text-field
            v-model="datos.telefonoDirExtincion"
            label="Teléfono Módulo D.E.*"
            type="tel"
            :rules="reglas.requerido"
            hide-details
          />
        </v-col>
        <v-col
          cols="3"
        >
          <v-text-field
            v-model="datos.frecuenciaAM"
            label="Frecuencia AM (MHz)*"
            :rules="reglas.requerido"
            hide-details
          />
        </v-col>
        <v-col
          cols="3"
        >
          <v-text-field
            v-model="datos.idAeronave"
            label="Id. Aeronave Mando / ACO"
            hide-details
          />
        </v-col>
      </v-row>

      <v-row
        class="align-center"
      >
        <v-col
          cols="4"
        >
          <v-radio-group
            v-model="datos.tipoComunicacion"
            row
            label="Comunicaciones terrestres*:"
            :rules="reglas.requerido"
            hide-details
            class="mt-0"
          >
            <v-radio
              label="Analógica"
              value="Analógica"
            />
            <v-radio
              label="Digital"
              value="Digital"
            />
            <v-radio
              label="Ambas"
              value="Ambas"
            />
          </v-radio-group>
        </v-col>
        <v-col
          cols="2"
        >
          <v-text-field
            v-model="datos.frecuenciaFM"
            label="Frec. FM"
            hide-details
          />
        </v-col>

        <v-col
          cols="2"
        >
          <v-select
            v-model="datos.canal"
            :items="canales"
            item-text="nombre"
            item-value="nombre"
            label="Canal"
            hide-details
            clearable
            @change="completarCanal"
          />
        </v-col>
        <v-col
          cols="2"
        >
          <v-text-field
            v-model="datos.tx"
            label="Tx"
            hide-details
          />
        </v-col>
        <v-col
          cols="2"
        >
          <v-text-field
            v-model="datos.rx"
            label="Rx"
            hide-details
          />
        </v-col>
      </v-row>

      <v-divider
        class="my-6"
      />

      <v-row>
        <v-col
          cols="6"
        >
          <v-card
            outlined
            class="pa-3"
          >
            <div
              class="subtitle-1 font-weight-bold primary--text mb-2"
            >
              Punto repostaje aeronaves
            </div>
            <v-combobox
              v-model="datos.ptoRepostaje"
              :items="bases"
              item-text="nombre"
              item-value="nombre"
              label="Punto repostaje*"
              :rules="reglas.requerido"
              clearable
              hide-details
              @change="completarBaseCoords"
            />
            <v-row>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="datos.yAereo"
                  label="Latitud"
                  hide-details
                />
              </v-col>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="datos.xAereo"
                  label="Longitud"
                  hide-details
                />
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col
          cols="6"
        >
          <v-card
            outlined
            class="pa-3"
          >
            <div
              class="subtitle-1 font-weight-bold primary--text mb-2"
            >
              Punto encuentro terrestres
            </div>
            <v-text-field
              v-model="datos.ptoEncuentro"
              label="Punto encuentro o base de descanso"
              class="mb-2"
              hide-details
            />
            <v-row>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="datos.yTerrestre"
                  label="Latitud"
                  hide-details
                />
              </v-col>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="datos.xTerrestre"
                  label="Longitud"
                  hide-details
                />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: { type: Object, required: true },
    canales: { type: Array, default: () => [] },
    bases: { type: Array, default: () => [] }
  },
  data: () => ({
    reglas: { requerido: [v => !!v || 'Campo obligatorio'] }
  }),
  computed: {
    datos: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  methods: {
    completarCanal(nombreCanal) {
      if (!nombreCanal) {
        this.datos.tx = ''
        this.datos.rx = ''
        return
      }
      const canalEncontrado = this.canales.find(c => c.nombre === nombreCanal)
      if (canalEncontrado) {
        this.datos.tx = canalEncontrado.tx
        this.datos.rx = canalEncontrado.rx
      }
    },

    completarBaseCoords(base) {
      if (!base) {
        this.datos.xAereo = ''
        this.datos.yAereo = ''
        return
      }

      const baseEncontrada = this.bases.find(b => b.nombre === base.nombre)
      if (baseEncontrada) {
        this.datos.xAereo = baseEncontrada.lon
        this.datos.yAereo = baseEncontrada.lat
      }
    }
  }
}
</script>
